export default "__VITE_ASSET__d765f8b4__"